<template>
  
  <div class="mit-reserve-now-edit">
    <!-- <v-snackbar top :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
        <b>{{ status.message }}</b>
      </v-snackbar> -->
    <!-- <v-dialog persistent v-model="show" width="650" eager> -->
    <v-dialog persistent scrollable v-model="show" width="650" :fullscreen="isMobile">
      <v-dialog persistent v-model="dialogRecurring" width="400">
        <v-card>
            <v-card-title class="text-h7 grey lighten-2">
              <v-icon color="primary" class="pr-3">mdi-help-circle-outline</v-icon>Edit recurring event
              <v-spacer></v-spacer>
              <v-btn color="grey lighten-2" elevation="0" fab small @click="cancel()"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
            </v-card-title>

          <v-card-text class="pt-5">
              Do you want to edit this event or all recurring events?
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialogEditThisEvent">Edit This Event</v-btn>
            <v-btn color="primary" @click="dialogEditRecurring">Edit Recurring</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="dialogRecurringChanged" width="400">
        <v-card>
            <v-card-title class="text-h7 grey lighten-2">
              <v-icon color="amber" class="pr-3">mdi-alert</v-icon>Save Recurring Reservation
            </v-card-title>

          <v-card-text class="pt-5">
              If you have changed specific events in this series, your changes will be canceled and those events will match this recurring reservation again.
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialogRecurringChangedCancel">Cancel</v-btn>
            <v-btn color="primary" @click="dialogRecurringChangedSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="dialogDelete" width="400">
        <v-card>
            <v-card-title class="text-h7 grey lighten-2">
              <v-icon color="amber" class="pr-3">mdi-alert</v-icon>Delete Reservation
            </v-card-title>

          <v-card-text class="pt-5">
              Perminently delete this reservation?
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialogDelete = false;">Cancel</v-btn>
            <v-btn color="primary" @click="dialogConfirmedDeleteThisEvent">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      
        <v-card v-if="loadingAllSpaces || loadingReservationSpace || loadingReservation" style="height: 400px;">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              Loading...
            </v-col>
            <v-col cols="6">
              <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
        </v-card>

        <v-card v-else-if="notfound" style="height: 400px;">
            <v-card-title class="text-h7 grey lighten-2">
                <!-- <span style="width: 450px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"><v-icon class="pr-3">mdi-calendar</v-icon>{{ selectedReservationExisting.name }}</span> -->
                <v-icon large color="red" class="pr-3">mdi-alert</v-icon>
                Not Found
                <v-spacer></v-spacer>
                   <v-btn color="grey lighten-2" elevation="0" fab small @click="cancel"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
            </v-card-title>
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              <h3>Reservation not found</h3>
              This reservation could not be found or you may not have access to it.
            </v-col>
          </v-row>
        </v-card>

        <v-card v-else>
          <v-card-title class="text-h5 grey lighten-2">
                <!-- <v-icon class="pr-3 pt-1" large>mdi-calendar-clock</v-icon>
                <span class="pr-5">{{ reservation.startDateDisplay1 }}</span><v-spacer></v-spacer>
                <span class="text-h6"><v-icon class="pr-3 pt-1">mdi-clock-outline</v-icon>{{ reservation.startTime1 }} - {{ reservation.endTime1 }}</span>
                <v-row no-gutters>
                    <v-col cols="12" class="pl-13">
                      <div class="body-1 grey--text text--darken-4">{{space.nameFormatted}}</div>
                      <div class="body-1 grey--text text--darken-4" style="text-transform: capitalize;">{{space.useType.toLowerCase()}}</div>
                    </v-col>
                </v-row> -->
                <div>
                  <v-row>
                    <v-col cols="12">
                      <v-icon class="pr-3 pt-1" large>mdi-calendar-clock</v-icon>
                      <span class="pr-5">{{ reservation.startDateDisplay1 }}</span>
                      <span class="text-h5">{{ reservation.startTime1 }} - {{ reservation.endTime1 }}</span>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                      <v-col cols="12" class="pl-13">
                        <div class="body-1">{{space.nameFormatted}}</div>
                        <div class="body-1" style="text-transform: capitalize;">{{space.useType.toLowerCase()}}</div>
                      </v-col>
                  </v-row>
                </div>
                
                <!-- <v-icon class="pr-3 pt-1" large>mdi-calendar-clock</v-icon>
                <span class="pr-5">{{ reservation.startDateDisplay1 }}</span>
                <span class="text-h6 font-weight-regular">{{ reservation.startTime1 }} - {{ reservation.endTime1 }}</span>
                <v-row no-gutters>
                    <v-col cols="12" class="pl-13">
                      <div class="body-1 grey--text text--darken-4">{{space.nameFormatted}}</div>
                      <div class="body-1 grey--text text--darken-4" style="text-transform: capitalize;">{{space.useType.toLowerCase()}}</div>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" class="pl-13">
                      <div class="body-1 grey--text text--darken-4">{{space.nameFormatted}}</div>
                      <div class="body-1 grey--text text--darken-4" style="text-transform: capitalize;">{{space.useType.toLowerCase()}}</div>
                    </v-col>
                </v-row> -->
                <!-- <div v-if="space.spaceType == 'object'">
                  {{space.name}} ({{ space.mitId.substring(0, space.mitId.indexOf(space.useType)-1) }})
                </div>
                <div v-else>
                  <span v-if="space.name">{{space.name}} ({{ space.mitId }})</span>
                  <span v-else>{{ space.mitId }}</span>
                </div> -->
                <!-- <div>
                  <v-icon x-large class="pr-3">mdi-calendar-clock</v-icon>
                  <span>{{ reservation.startDateDisplay1 }}</span>
                  <v-spacer/>
                  <span class="h4 grey--text text--darken-2">{{ reservation.startTime1 }} - {{ reservation.endTime1 }}</span>
                  <div class="text subtitle-1 grey--text text--darken-2">{{space.nameFormatted}}</div>
                </div> -->
                <!-- <div>
                  <v-row no-gutters>
                    <v-col cols="12" class="pa-0 ma-0">
                      <v-icon class="pr-3 pt-1" large>mdi-calendar-clock</v-icon>
                      <span class="pr-5">{{ reservation.startDateDisplay1 }}</span><v-spacer></v-spacer>
                      <span class="text-h6"><v-icon class="pr-3 pt-1" large>mdi-clock-outline</v-icon>{{ reservation.startTime1 }} - {{ reservation.endTime1 }}</span>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="12" class="pl-13">
                      <div class="body-1 grey--text text--darken-4">{{space.nameFormatted}}</div>
                      <div class="body-1 grey--text text--darken-4" style="text-transform: capitalize;">{{space.useType.toLowerCase()}}</div>
                    </v-col>
                  </v-row>
                </div> -->
                
                <!-- <v-row no-gutters>
                  <v-col cols="8" class="mr-auto">
                    <v-icon x-large>mdi-calendar-clock</v-icon>
                    <span>{{ reservation.startDateDisplay1 }}</span>
                    <div class="text subtitle-1 grey--text text--darken-2">{{ reservation.startTime1 }} - {{ reservation.endTime1 }}</div>
                  </v-col>
                  <v-col cols="4" class="ml-auto">
                    <div>{{space.nameFormatted}}</div>
                    <div v-if="space.org && space.org.length > 0" class="text subtitle-2 grey--text text--darken-1">{{space.org}}</div>
                    <div class="text subtitle-2 grey--text text--darken-1">{{space.useType}}</div>
                  </v-col>
                  
                </v-row> -->
                <!-- <div>{{space.nameFormatted}}</div> -->
                <!-- <v-spacer></v-spacer> -->
                <!-- <v-text-field
                  dense
                  style="max-width: 200px;"
                  label="Name (optional)"
                  hint="Name of the reservation"
                  v-model="reservation.name"
                  @change="nameChanged()"
                ></v-text-field> -->
            </v-card-title>
            <!-- <v-card-subtitle class="text grey lighten-2">
                <div v-if="space.org && space.org.length > 0">{{space.org}}</div>
                <div>{{space.useType}}</div>
            </v-card-subtitle> -->

            <!-- <v-card-text v-if="reservation" style="overflow-y: auto; height: calc(100vh - 250px);"> -->
            <v-card-text v-if="reservation">
                  <!-- Everything Below header -->
                  <v-row class="pt-5">
                      <!-- The left side of calendar -->
                      <v-col cols="12" md="6">


                        <v-row>
                          <v-col class="pt-0 pl-4 pr-4" cols="12">
                            <v-text-field :error-messages="errorsName" label="Name" v-model="reservation.name" prepend-icon="mdi-rename-outline" @change="nameChanged()"></v-text-field>
                          </v-col>
                        </v-row>
                          
                          <v-row no-gutters class="pb-2">
                              <v-col cols="6" md="6">
                                  <v-menu v-model="dateStartMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field v-model="computedDateFormatted" readonly label="Start Date" prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="reservation.startDate" no-title @input="startDateChanged()"></v-date-picker>
                                  </v-menu>
                              </v-col>
                              <v-col cols="6" md="6">
                                  <v-switch class="pl-5" v-model="reservation.allDay" label="All Day" :error-messages="errorsAllDay" @change="allDayChanged"></v-switch>
                              </v-col>
                          </v-row>
                          <v-row no-gutters v-if="!reservation.allDay">
                              <v-col cols="6" md="6">
                                <v-select
                                  :items="timeList"
                                  menu-props="auto"
                                  v-model="reservation.startTime"
                                  label="Start Time"
                                  required
                                  prepend-icon="mdi-clock-time-three-outline"
                                  :error-messages="errorsTime"
                                  @change="startTimeChanged"
                                ></v-select>
                              </v-col>
                              <v-col cols="6" md="6">
                                  <v-select
                                    class="pl-8"
                                    :items="durations"
                                    menu-props="auto"
                                    item-text="text"
                                    item-value="value"
                                    v-model="reservation.duration"
                                    label="Duration"
                                    required
                                    @change="durationTimeChanged"
                                  ></v-select>
                              </v-col>
                              <v-col v-if="reservation.owner" cols="12" md="12">
                                <v-text-field readonly label="Owner (CSAIL ID)" v-model="reservation.owner" prepend-icon="mdi-account"></v-text-field>
                              </v-col>
                              </v-row>
                              <v-row class="pa-0" v-if="reservation.recurring">
                                  <v-col class="pt-0 pb-0 mb-0" cols="12">
                                      <v-select 
                                        :items="repeatOptions"
                                        v-model="reservation.recurring.repeatChoice"
                                        label="Repeats"
                                        prepend-icon="mdi-repeat-variant"
                                        required
                                        @change="recurringTypeChanged"
                                      ></v-select>
                                  </v-col>
                                  <span  v-if="reservation.recurring.repeatChoice == 'weekly'">
                                    <v-col class="pt-0" cols="12">
                                        <v-btn class="mx-0 mr-1" elevation="0" fab x-small :color="reservation.recurring.days.monday ? 'primary':'gray'" @click="dayClick('monday')">M</v-btn>
                                        <v-btn class="mx-0 mr-1" elevation="0" fab x-small :color="reservation.recurring.days.tuesday ? 'primary':'gray'" @click="dayClick('tuesday')">T</v-btn>
                                        <v-btn class="mx-0 mr-1" elevation="0" fab x-small :color="reservation.recurring.days.wednesday ? 'primary':'gray'" @click="dayClick('wednesday')">W</v-btn>
                                        <v-btn class="mx-0 mr-1" elevation="0" fab x-small :color="reservation.recurring.days.thursday ? 'primary':'gray'" @click="dayClick('thursday')">T</v-btn>
                                        <v-btn class="mx-0 mr-1" elevation="0" fab x-small :color="reservation.recurring.days.friday ? 'primary':'gray'" @click="dayClick('friday')">F</v-btn>
                                        <v-btn class="mx-0 mr-1" elevation="0" fab x-small :color="reservation.recurring.days.saturday ? 'primary':'gray'" @click="dayClick('saturday')">Sa</v-btn>
                                        <v-btn class="mx-0" elevation="0" fab x-small :color="reservation.recurring.days.sunday ? 'primary':'gray'" @click="dayClick('sunday')">Su</v-btn>
                                    </v-col>
                                    <v-col class="pt-0" cols="12">
                                      <v-row class="pa-0 ma-0 pl-3">
                                        <v-col class="pa-0 ma-0 pt-1" cols="2">Every</v-col>
                                        <v-col class="pa-0 ma-0" cols="3">
                                          <v-select class="pa-0 ma-0"
                                            dense
                                            hide-details
                                            :items="weeklyInterval"
                                            v-model="reservation.recurring.weeklyInterval"
                                            style="max-width:45px"
                                            @change="weeklyIntervalChanged"
                                          ></v-select>
                                        </v-col>
                                        <v-col class="pa-0 ma-0 pt-1" cols="3">week(s)</v-col>
                                      </v-row>
                                    </v-col>
                                    <v-col class="pt-0" cols="12">
                                        <v-menu ref="dateEndMenu" v-model="dateEndMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                          <template v-slot:activator="{ on, attrs }">
                                              <span v-bind="attrs" v-on="on">Occurs every 
                                                  <span v-for="(item, name) in reservation.recurring.days" :key="name" style="text-transform: capitalize;"><span v-if="item" class="primary--text">{{name.substring(0,3)+', '}}</span></span>
                                                until <span class="primary--text" style="text-decoration: underline;">{{reservation.recurring.repeatsUntilDate.format('ddd MMM DD YYYY')}}</span></span>
                                          </template>
                                          <v-date-picker v-model="reservation.recurring.repeatsUntilDateString" no-title @input="recurringEndDateChanged"></v-date-picker>
                                        </v-menu>
                                        <p class="red--text" style="font-size: 12px;">{{errorsRecurringEndDate[0] }}</p>
                                    </v-col>
                                  </span>
                                  <v-col class="pt-3" cols="12" v-if="reservation.recurring.repeatChoice == 'monthly'">
                                      <v-menu ref="dateEndMenu" v-model="dateEndMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">Occurs every day {{ reservation.startDateTime.format('D') }} of each month until <span class="primary--text">{{reservation.recurring.repeatsUntilDate.format('ddd MMM DD YYYY')}}</span></span>
                                        </template>
                                        <v-date-picker v-model="reservation.recurring.repeatsUntilDateString" no-title @input="recurringEndDateChanged"></v-date-picker>
                                      </v-menu>
                                      <p class="red--text" style="font-size: 12px;">{{errorsRecurringEndDate[0] }}</p>
                                  </v-col>
                          </v-row>
                      </v-col>

                      <!-- The Calendar side -->
                      <v-col class="pa-0" cols="12" md="6">
                          <v-card v-if="loadingExistingReservations" elevation="0" height="400">
                              <v-card-text class="text-center">
                                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                  <div>Loading...</div>
                              </v-card-text>
                          </v-card>
                          <BaseMitCalendar :height="350" v-if="!loadingExistingReservations" :focusTime="reservation.startTime" :calendarDate="reservation.startDateTime" :events="calendarReservations"/>
                      </v-col>

                </v-row>
                <!-- Below the calendar and date time config -->
                <v-row>
                    <v-col cols="12" class="pl-0 pr-0">
                        <v-expansion-panels v-model="expansionOpen">
                          
                          <v-expansion-panel v-if="reservation.recurring && reservation.recurring.repeatChoice">
                              <v-expansion-panel-header class="pt-0 pb-0" color="grey lighten-4">
                                <span><v-icon v-if="conflicts.length > 0" :color="(ignoreConflicts) ? 'amber' : 'red'" class="pr-3">mdi-alert</v-icon> <v-icon v-else color="success" class="pr-3">mdi-check-circle-outline</v-icon>Conflicts ({{conflicts.length}})</span>
                                <v-spacer/>
                                <v-checkbox color="primary lighten-1" :error-messages="errorsConflicts" @click="ignoreConflictsChecked" v-if="conflicts.length > 0" max-width="10px" class="pb-2 pr-5 shrink" @click.native.stop dense v-model="ignoreConflicts" hide-details label="Ignore">
                                </v-checkbox>       
                              </v-expansion-panel-header>
                              <v-expansion-panel-content style="border: 1px solid #eee;">
                                  <v-simple-table>
                                      <template v-slot:default>
                                          <thead>
                                              <tr>
                                                <th class="text-left">My Reservation</th>
                                                <th class="text-left">Conflicting Reservation</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr v-for="(res, i) in conflicts" :key="i">
                                                <td>
                                                      <v-row>
                                                        <v-col cols="2">
                                                          <v-icon color="red">mdi-calendar-alert</v-icon>
                                                        </v-col>
                                                        <v-col cols="10">
                                                          <div><b>{{reservation.recurring.events[res.potentialResIdInConflict].startTime.format('ddd MMM DD YYYY') }}</b></div>
                                                          <div>{{reservation.recurring.events[res.potentialResIdInConflict].startTime.format('h:mm A')}} for {{reservation.recurring.events[res.potentialResIdInConflict].startTime.from(reservation.recurring.events[res.potentialResIdInConflict].endTime,true)}} </div>
                                                        </v-col>
                                                      </v-row>
                                                </td>
                                                <td>
                                                      <v-row>
                                                        <v-col cols="2">
                                                          <v-icon>mdi-calendar</v-icon>
                                                        </v-col>
                                                        <v-col cols="10">
                                                          <div><b>{{res.startDateTime.format('ddd MMM DD YYYY')}}</b></div>
                                                          <div>{{res.startDateTime.format('h:mm A')}} for {{res.startDateTime.from(res.endDateTime,true)}} </div>
                                                        </v-col>
                                                      </v-row>
                                                </td>
                                              </tr>
                                          </tbody>
                                      </template>
                                  </v-simple-table>
                                   
                              </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                              <v-expansion-panel-header class="pt-0 pb-0" color="grey lighten-4">
                                <span><v-icon class="pr-3">mdi-comment-question-outline</v-icon>Setup Help</span>
                                <v-spacer/> 
                                <span style="width:10px">
                                  <span v-if="reservation.setupState == setupStateDict.requested.val"><v-icon  color="'amber'" class="pr-3">mdi-progress-wrench</v-icon> {{  setupStateDict.requested.name }}</span>
                                  <span v-else-if="reservation.setupState == setupStateDict.completed.val"><v-icon color="success" class="pr-3">mdi-check-circle-outline</v-icon> {{  setupStateDict.completed.name }}</span>
                                  <span v-else-if="reservation.setupState == setupStateDict.contact.val"><v-icon color="red" class="pr-3">mdi-alert-circle-outline</v-icon> {{  setupStateDict.contact.name }}</span>
                                </span>
                              </v-expansion-panel-header>
                              <!-- <v-expansion-panel-header class="pt-0 pb-0" color="grey lighten-4">
                                <span><v-icon class="pr-3">mdi-comment-question-outline</v-icon>Setup Help</span>
                                <v-spacer/>   
                              </v-expansion-panel-header> -->
                              <v-expansion-panel-content class="pa-0 ma-0" style="border: 1px solid #eee;">
                                <v-card flat class="pa-0 ma-0">
                                  
                                  <v-card-text class="pb-0">
                                    <span v-if="reservation.setupState == setupStateDict.requested.val"><span><b>Status:</b></span> <v-icon  color="'amber'">mdi-progress-wrench</v-icon> {{  setupStateDict.requested.hint }}<span><v-btn class="ml-10" small color="red lighten-1" @click="reservation.setupDescription = null; requestHelpDescChanged()">Cancel Request</v-btn></span></span>
                                    <span v-else-if="reservation.setupState == setupStateDict.completed.val"><span><b>Status:</b></span> <v-icon color="success">mdi-check-circle-outline</v-icon> {{  setupStateDict.completed.hint }}</span>
                                    <span v-else-if="reservation.setupState == setupStateDict.contact.val"><span><b>Status:</b></span> <v-icon color="red">mdi-alert-circle-outline</v-icon> {{  setupStateDict.contact.hint }}</span>
                                    <!-- <v-checkbox v-model="requestSetupHelp" label="Request Setup Help"></v-checkbox> -->
                                     <v-textarea rows="3" counter maxlength="200" outlined @change="requestHelpDescChanged" class="pa-2 mt-2 pb-0" v-model="reservation.setupDescription" label="Description of setup needed."></v-textarea>
                                  </v-card-text>
                                  <v-card-subtitle>**Request help from TIG to set up a space. Please note, 48 hours notice is required.</v-card-subtitle>
                                </v-card>
                              </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                              <v-expansion-panel-header class="pt-0 pb-0" color="grey lighten-4">
                                <span><v-icon class="pr-3">mdi-account-multiple</v-icon>Additional Owners</span>
                                <v-spacer/>   
                              </v-expansion-panel-header>
                              <v-expansion-panel-content style="border: 1px solid #eee;">
                                <BaseMitCsailMultiUsers flat :outlined="false" title="Additional Owners" subtitle="Optionally add users that can edit this reservation" :defaultSelectedUsers="reservation.secondaryOwners" @user-changed="changedAllowedUser"/>
                              </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel v-if="reservationHistory.length > 0">
                              <v-expansion-panel-header color="grey lighten-4">
                                History ({{reservationHistory.length}})
                              </v-expansion-panel-header>
                              <v-expansion-panel-content style="border: 1px solid #eee;">
                                <BaseMitReservationActivityListSimple :reservationActivity="reservationHistory" showDetails/>
                            </v-expansion-panel-content>
                            </v-expansion-panel>

                      </v-expansion-panels>

                    </v-col>
                </v-row>
                <v-row>
                    <span v-if="errorsConflicts.length > 0" class="red--text" style="font-size: 12px;">**{{errorsConflicts[0] }}</span>
                </v-row>
                <v-row v-if="reservation.id">
                    <v-btn class="mb-3" color="red" block @click="deleteClick">Delete</v-btn>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-end">
                <v-btn text @click="cancel">Cancel</v-btn>
                <v-btn color="primary" @click="saveClick">Save</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
  </div>
</template>

<script>
  import moment from 'moment';
  import BaseMitLoading from '../BaseMitLoading.vue';
  import BaseMitCsailMultiUsers from '../csail-users/BaseMitCsailMultiUsers.vue';

  import BaseMitCalendar from './BaseMitCalendar.vue';
  import BaseMitReservationActivityListSimple from './BaseMitReservationActivityListSimple.vue';

  import MitActivityApiService from '../../services/BaseMitReserveActivityApiService.js';
  import MitSpacesApiService from '../../services/BaseMitReserveSpacesService.js';
  import MitReserveService from '../../services/BaseMitReserveService.js';
  import MitDateTimeService from '../../services/BaseMitReserveDateTimeService.js';

export default {
  name: 'MitReserveEdit',
  components: {
      BaseMitLoading,
      BaseMitCsailMultiUsers,
      // BaseMitDataTable,
      BaseMitCalendar,
      BaseMitReservationActivityListSimple
  },
  props: {
      managerMode:{
        default () {
          return false;
        },
        type: Boolean
      },
      selectedSpace:{
        default () {
          return null;
        },
        type: Object
      },
      allSpaces:{
        default () {
          return [];
        },
        type: Array
      },
      existingReservationUniqueId:{
        default () {
          return null;
        },
        type: String
      },
      existingReservation:{
        default () {
          return null;
        },
        type: Object
      },
      show:{
        default () {
          return false;
        },
        type: Boolean
      }

  },
  data: function() {
    return {
        status:{
          display:false,
          timeout:3000,
          message:'Saved!',
          color:'primary'
        },
        notfound:false,
        dialogRecurring:false,
        dialogRecurringChanged:false,
        dialogDelete:false,
        errorsRecurringEndDate:[],
        errorsAllDay:[],
        errorsTime:[],
        errorsConflicts:[],
        errorsName:[],
        clickedDay:false,
        isTimeValid:false,
        isRecurringEndTimeValid:false,
        existingReservations:[],
        loadingReservation:true,
        loadingExistingReservations:true,
        loadingAllSpaces:true,
        loadingReservationSpace:true,
        ignoreConflicts:false,
        dateStartMenu:false,
        dateEndMenu:false,
        durations:[],
        duration:null,
        timeList:[],
        calendarCurrentTime:moment().format("hh:mm"),
        calendarValue:null,
        calendarReservations: [],
        calendarCurrentReservation:{
            name: '',
            start: moment().toDate(),
            end: moment().add(60, 'm').toDate(),
            color: 'primary',
            timed: true
        },
        expansionOpen:false,
        requestSetupHelp:false,
        repeatOptions:null,
        weeklyInterval:[1,2,3,4],
        reservation:null,
        reservationHistory:[],
        reservationId:null,
        conflicts:[],
        setupStateDict:MitReserveService.getSetupStateDict(),
        mitDateTimeService: new MitDateTimeService()
    }
  },
  watch: {
      existingReservationUniqueId(newVal, oldVal) {
          this.reservationId = newVal;
      },
      show(newVal, oldVal) {
          if(newVal){
            this.reservationId = this.existingReservationUniqueId;
            this.init();
          }
          else{
            //clean up
          }
      }
  },
  computed: {
      isMobile () {
        //return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm';
        return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm';
      },
      computedDateFormatted () {
        return this.reservation.startDate ? moment(this.reservation.startDate).format('MMM Do YYYY') : ''
      }
  },
  created(){
      
  },
  mounted() {

  },
  methods : {
      init(){
        this.repeatOptions = MitReserveService.repeatOptions();
        this.durations = this.mitDateTimeService.timeDurations;
        this.timeList = this.mitDateTimeService.getTimes();
        this.defaultTimes = this.mitDateTimeService.getDefaultTimes(this.timeList,60);

        //reset state
        this.ignoreConflicts = false;
        this.conflicts = [];
        this.isTimeValid = false;
        this.sRecurringEndTimeValid = false;
        this.requestSetupHelp = false;
        this.expansionOpen = false;//close all expansion panels

        //refresh the latest reservation if needed and then get all other info based on that.
        this.requestReservation(this.existingReservation, this.reservationId)
              .then((reservation) => {

                  if(reservation){
                    this.notfound = false;
                      const promises = [
                            this.requestExistingReservationsForSpace(this.reservation),
                            this.requestReservationHistory(this.reservation.uniqueId),
                            this.requestSelectedSpace(this.reservation.mitId, this.selectedSpace), 
                            this.requestAllSpaces(this.allSpaces)
                          ];

                      Promise.allSettled(promises).then((results) =>{
                        this.updateCurrentReservationStartEnd(this.reservation);
                        //this.recurringEndDateSetDefaultIfOutOfRange(this.reservation); //needed for case when the user changes the start date from 
                        this.checkIsValid(this.reservation, this.existingReservations);
                        this.isFormValid();
                      })
                      .catch((error) => {
                        console.log('ERROR:', error);
                      });

                      if(this.reservation.setupHelp !== null){
                        this.requestSetupHelp = true;
                      }

                      if(this.reservation.recurringUniqueId){
                        this.dialogRecurring = true;
                      }
                      if(this.$route.query.delete){
                        this.dialogDelete = true;
                      }

                      //Need to check and see, this is for editing case
                      //generate and refresh based on existing settings
                      this.generateRecurringEventsIfNeeded(this.reservation);
                  }
                  else{
                    this.loadingAllSpaces = false;
                    this.loadingReservationSpace = false;
                    this.loadingReservation = false;
                    this.notfound = true;
                  }
                  
                  
              })
              .catch((error) => {
                    console.log('ERROR:', error);
                });
      
      },
      dialogRecurringChangedCancel(){
        this.dialogRecurringChanged = false;
        //do nothing, return to main dialog
      },

      dialogRecurringChangedSave(){
        this.dialogRecurringChanged = false;
        //User is ok with this so just save
        this.save();
      },
      dialogEditThisEvent(){
        this.dialogRecurring = false;
        //do nothing we just will edit htis
      },
      dialogEditRecurring(){
        this.dialogRecurring = false;
        // Change this event to the parent and refresh
        this.reservationId = this.reservation.recurringUniqueId;
        this.$emit('changed-reservation', this.reservationId);
        this.init();
      },
      dialogConfirmedDeleteThisEvent(){
        this.dialogDelete = false;
        this.delete();
      },
      deleteClick(){
        this.dialogDelete = true;
      },
      isFormValid(){
        let isValid = true;
        this.errorsAllDay = [];
        this.errorsTime = [];
        this.errorsRecurringEndDate = [];
        this.errorsConflicts = [];
        this.errorsName=[];


        if(this.reservation.name != null && this.reservation.name.length <= 0){
          isValid = false;
          this.errorsName = ["Name this reservation"];
        }

        //Evaluate
        if(this.isTimeValid === false){
            isValid = false;
            if(this.reservation.allDay){
                this.errorsAllDay = ["Time conflicts with existing reservation"];
            }
            else{
                this.errorsTime = ["Time conflicts with existing reservation"];
            }
        }
        if(this.isRecurringEndTimeValid === false){
          isValid = false;
          this.errorsRecurringEndDate = ["Date must be less than 1 year and end after the start time"];
        }

        if(this.ignoreConflicts === false && this.conflicts.length > 0){
          isValid = false;
          this.errorsConflicts = ["Check ignore to create the reservation and skip conflicting dates"];
        }


        return isValid;
      },
      ignoreConflictsChecked(){
        this.isFormValid();
      },
      allowFutureDatesOnly(val) {
          let d = moment(val, 'YYYY-MM-DD');
          let dMax = moment(this.reservation.startDateTime).add(1, 'years');
          return d.isAfter(moment()) && d.isBefore(dMax);
      },
      dayClick(day){
         this.clickedDay = true;
         this.reservation.recurring.days[day] = !this.reservation.recurring.days[day];
         this.generateRecurringEventsIfNeeded(this.reservation);
      },
      recurringTypeChanged(val){
          //this.recurringEndDateSetDefaultIfOutOfRange(this.reservation);

          if(this.clickedDay === false && (this.reservation.id === null || typeof this.reservation.id ===  'undefined')){
              //set the default
              this.reservation.recurring.days[this.mitDateTimeService.getCurrentDayOfWeek(this.reservation.startDateTime)] = true;
            }
          //evaluate the default recurring choice here
          this.generateRecurringEventsIfNeeded(this.reservation);
      },
      weeklyIntervalChanged(interval){
        this.generateRecurringEventsIfNeeded(this.reservation);
      },
      generateRecurringEventsIfNeeded(reservation){
          if(reservation.recurring && reservation.recurring.repeatChoice){
            reservation.recurring.events = MitReserveService.generateRecurringEvents(reservation);
            this.requestRecurringConflicts(reservation);
          }
      },
      requestRecurringConflicts(reservation){
          if(reservation.recurring && reservation.recurring.events.length > 0){
              this.loadingConflicts = true;
              let utcEvents = this.mitDateTimeService.convertRecurringDatesListToUTCString(reservation.recurring.events);
              MitSpacesApiService.getSpacesWithConflicts(utcEvents, reservation)
                .then((data) => {
                    this.loadingConflicts = false;
                    this.conflicts = data.spaces.dict[reservation.mitId].conflicts;
                    this.isFormValid();//check form again after new request for conflicts
                })
                .catch((error) => {
                    this.loadingConflicts = false;
                    this.status.message = 'An error occurred trying to evaluate potential conflicts.';
                    this.status.display = true;
                    this.status.color = 'red';
                    console.log('ERROR:', error);
                });
          }

      },
      requestExistingReservationsForSpace(reservation){
          this.loadingExistingReservations = true;
          let startUTC = moment(reservation.startDateTime).startOf('day').utc().format('YYYY-MM-DD hh:mm A');
          let endUTC = moment(reservation.endDateTime).endOf('day').utc().format('YYYY-MM-DD hh:mm A');
          return new Promise ((resolve, reject) => {
          
              MitReserveService.getExistingReservationsBySpace([reservation.mitId], startUTC, endUTC, [reservation.uniqueId])
                .then((data) => {
                    this.existingReservations = data.reservations;

                    this.setExistingReservationsInCalendar(this.existingReservations)
                    this.loadingExistingReservations = false;
                    return resolve(this.existingReservations)
                })
                .catch((error) => {
                    this.loadingExistingReservations = false;
                    this.status.message = 'An error occurred trying to get the reservations for spaces '+reservation.mitId;
                    this.status.display = true;
                    this.status.color = 'red';

                    console.log('ERROR:', error);
                    return reject(error);
                });
          });
      },
      getRequestReservation(uniqueId){
        if(this.managerMode){
          return MitReserveService.getReservationByUniqueId(uniqueId);
        }

        return MitReserveService.getMyReservationByUniqueId(uniqueId);
      },
      requestReservation(reservation,uniqueId){
          this.loadingReservation = true;

          return new Promise ((resolve, reject) => {
            if(reservation){
              //New reservations come in here for now.
              this.reservation = MitReserveService.copy(reservation);
              this.loadingReservation = false;
              return resolve(this.reservation);
            }

            return this.getRequestReservation(uniqueId)
                .then((data) => {
                    this.reservation = data;
                    this.loadingReservation = false;
                    return resolve(this.reservation);
                })
                .catch((error) => {
                    this.loadingReservation = false;
                    this.status.message = 'An error occurred trying to get the reservation';
                    this.status.display = true;
                    this.status.color = 'red';

                    console.log('ERROR:', error);
                    return reject(error);
                });
            });

          
      },
      getRequestHistory(uniqueId){
        if(this.managerMode){
          return MitActivityApiService.requestGetReservationActivity(uniqueId);
        }

        return MitActivityApiService.requestGetMyReservationActivity(uniqueId);
      },
      requestReservationHistory(uniqueId){
        if(uniqueId){
          return this.getRequestHistory(uniqueId)
            .then((data) => {
                this.reservationHistory = data.activity;
            })
            .catch((error) => {
                this.status.message = 'An error occurred trying to get the reservation';
                this.status.display = true;
                this.status.color = 'red';

                console.log('ERROR:', error);
            });
        }
          
      },
      requestAllSpaces(allSpaces){
          this.loadingAllSpaces = true;

          if(allSpaces && allSpaces.length > 0){
            this.spaces = allSpaces;
            this.loadingAllSpaces = false;
            return Promise.resolve(true);
          }

          return MitSpacesApiService.getReservableSpaces()
            .then((data) => {
                this.spaces = data.spaces;
                this.loadingAllSpaces = false;
            })
            .catch((error) => {
                this.loadingAllSpaces = false;
                this.status.message = 'An error occurred trying to get the reservable spaces list';
                this.status.display = true;
                this.status.color = 'red';

                console.log('ERROR:', error);
            });
      },
      requestSelectedSpace(mitId, selectedSpace){
          this.loadingReservationSpace = true;

          if(selectedSpace){
            this.space = selectedSpace;
            this.loadingReservationSpace = false;
            return Promise.resolve(true);
          }

          return MitSpacesApiService.getReservableSpace(mitId)
            .then((space) => {
                this.space = space;
                this.loadingReservationSpace = false;
            })
            .catch((error) => {
                this.loadingReservationSpace = false;
                this.status.message = 'An error occurred trying to get the reservable spaces list';
                this.status.display = true;
                this.status.color = 'red';

                console.log('ERROR:', error);
            });
      },
      setExistingReservationsInCalendar(reservations){
          //clear the array while maintaining its address in memory since its passed to the calendar component and used.
          this.calendarReservations.splice(0, this.calendarReservations.length);

          for(let x = 0; x < reservations.length; x++){
            this.calendarReservations.push({
                name: reservations[x].name,
                start: reservations[x].startDateTime.toDate(),
                end: reservations[x].endDateTime.toDate(),
                color: 'grey darken-1',
                timed: true
            })
          }

          //now add the current reseration the user is trying to make or edit
          this.calendarReservations.push(this.calendarCurrentReservation);
      },
      requestHelpDescChanged(){
        //Test to see if there was a text change
        //manipulate the 
        MitReserveService.setSetupValueDescriptionChanged(this.reservation);
      },
      nameChanged(){
        this.updateCurrentReservationStartEnd(this.reservation);
      },
      cancel(){
          this.$emit('cancel');
      },
      delete(){
        this.$emit('delete', this.reservation);
      },
      save(){
        //if this is recurring and the user has 
        if(MitReserveService.isRecurring(this.reservation) && this.ignoreConflicts){
          this.reservation.recurring.conflictsIgnored = [];
          //from the list of existing reservations in conflict, look up my reservation that is conflicting and add it to the ignore list in local time.
          for(let x = 0; x < this.conflicts.length; x++){
            //Remove the ignored event from the list and put it into the ignored list
            this.reservation.recurring.conflictsIgnored.push(
                this.reservation.recurring.events.splice(this.conflicts[x].potentialResIdInConflict, 1)[0]
            );
          }
        }
        this.$emit('save', this.reservation);
      },
      saveClick(){
          if(this.isFormValid()){
            if(MitReserveService.isRecurring(this.reservation) && this.reservation.id){
                this.dialogRecurringChanged = true;
            }
            else{
               this.save();
            }
          }
      },
      allDayChanged(){
        if(this.reservation.allDay === false){
            //if we are switching off from all day, switch the time back to default
            MitReserveService.setToDefaultDateTime(this.reservation);
        }
        this.updateCurrentReservationStartEnd(this.reservation);
        this.checkIsValid(this.reservation, this.existingReservations);
        this.isFormValid();
        this.generateRecurringEventsIfNeeded(this.reservation);
      },
      recurringEndDateSetDefaultIfOutOfRange(reservation){
          //If The reservation recurring end time is not valid adjust it.
          //The user may have put it outside the bounds
          //Don't do this everywhere, only do this automatically when moving the start date puts the recurring end date out of bounds
          //The stance I am taking here is let the user directly manipulate fields how they like, then give them feedback when they press save
          //The exception is when manipulating a field effects another property indirectly
          if(reservation.recurring){
            //Only do this for brand new reservations that are recurring
            //otherwise the user has already saved a date so lets not mess with it.
            let d = moment(reservation.recurring.repeatsUntilDate);
            let dMax = moment(reservation.startDateTime).endOf('day').add(1, 'years');
            if((d.isBefore(moment()) || d.isAfter(dMax)) ){
              MitReserveService.updateRecurrinEndDateDefault(reservation);
            }
          }        
      },
      recurringEndDateChanged(){
          this.dateEndMenu = false;

          this.updateCurrentReservationStartEnd(this.reservation);

          this.requestExistingReservationsForSpace(this.reservation)
                .then((existingReservations) => {
                    this.checkIsValid(this.reservation, this.existingReservations);
                    this.isFormValid();
                    this.generateRecurringEventsIfNeeded(this.reservation);
                });
          
          
      },
      startDateChanged(){
          this.dateStartMenu = false;

          this.updateCurrentReservationStartEnd(this.reservation);
          
          this.recurringEndDateSetDefaultIfOutOfRange(this.reservation);

          this.requestExistingReservationsForSpace(this.reservation)
                .then((existingReservations) => {
                    this.checkIsValid(this.reservation, this.existingReservations);
                    this.isFormValid();
                    this.generateRecurringEventsIfNeeded(this.reservation);
                });
          
          
      },
      startTimeChanged(time){
          this.updateCurrentReservationStartEnd(this.reservation);
          this.checkIsValid(this.reservation, this.existingReservations);
          this.isFormValid();
          this.generateRecurringEventsIfNeeded(this.reservation);
      },
      durationTimeChanged(duration){

          this.updateCurrentReservationStartEnd(this.reservation);
          this.checkIsValid(this.reservation, this.existingReservations);
          this.isFormValid();
          this.generateRecurringEventsIfNeeded(this.reservation);
      },
      //updateCurrentReservationStartEnd(name, startDateString,startTimeString, duration, allDay ){
      updateCurrentReservationStartEnd(reservation){

          //Update the reservation times, there are several formats needed that all need to be in sync
          //This is because different components need various string or javascript date objects and for our
          //purposes dealing with moment date time objects is easier and less buggy so we have to maintain them here.
          this.reservation = MitReserveService.updateDateTime(reservation);

          

          this.calendarCurrentReservation.name = this.reservation.name;
          this.calendarCurrentReservation.start = this.reservation.startDateTime.toDate();
          this.calendarCurrentReservation.end = this.reservation.endDateTime.toDate();

      },
      checkIsValid(reservation, existingReservations){
        //Check for conflicts
          //get only the current mitId reservations
          //Check for conflicts
          if(this.mitDateTimeService.checkDateConfictsInReservations(existingReservations, reservation.startDateTime, reservation.endDateTime)){
              this.isTimeValid = false;
              this.calendarCurrentReservation.color = 'red';
          }
          else{
              this.isTimeValid = true;
              this.calendarCurrentReservation.color = 'primary';
          }

          this.isRecurringEndTimeValid = true;
          //Test the recurring end date
          if(this.reservation.recurring){
            let d = moment(this.reservation.recurring.repeatsUntilDate);
            let dMax = moment(this.reservation.startDateTime).endOf('day').add(1, 'years');
            if((d.isBefore(moment()) || d.isAfter(dMax)) ){
                this.isRecurringEndTimeValid = false;
            }
          }
          
      },
      changedAllowedUser(items){
          //TODO:
          // Make sure users can't be added 2 times
          //probably should be implemented in the base control for adding users.
          this.reservation.secondaryOwners = items.map(a => a.id);
      }
  }
}
</script>

<style lang="scss" scoped>
    //this is a for a "bug" fix on the stepper when no shadow is selected there is still a shadow on the header
    .v-stepper__header {
        box-shadow: none;
    }

</style>
